'use client'

import { Button } from '@/components/ui/button'
import { Cookie } from 'lucide-react'
import { ConsentDialogLink } from '@c15t/nextjs/components/consent-dialog-link'

export const CookieButton = () => {
  return (
    <ConsentDialogLink asChild>
      <Button
        variant="outline-solid"
        size="sm"
        className="fixed bottom-4 left-4 z-50 border-gray-200 bg-white/90 shadow-lg backdrop-blur-xs transition-all duration-200 hover:bg-white hover:shadow-xl"
      >
        <Cookie className="h-4 w-4" />
      </Button>
    </ConsentDialogLink>
  )
}
